import { render, staticRenderFns } from "./editCorpus.vue?vue&type=template&id=2a48d817&scoped=true&"
import script from "./editCorpus.vue?vue&type=script&lang=js&"
export * from "./editCorpus.vue?vue&type=script&lang=js&"
import style0 from "./editCorpus.vue?vue&type=style&index=0&id=2a48d817&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48d817",
  null
  
)

export default component.exports